import { Chart } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  colors,
  legendLabelsConfig,
  numberToCurrency,
  numberToPercentage,
} from './utils';

export const createEngagementChart = (graphData, scope) => {
  const chartCanvas = document.getElementById('engagementChartCanvas');

  if (!chartCanvas) {
    return;
  }

  const chartLoader = document.getElementById('engagementChartLoader');
  chartLoader.classList.remove('lds-dual-ring');

  const tooltipBody = (item) => {
    const fundName = item.label;
    const amountAsCurrency = numberToCurrency(item.raw);

    return ` Engagement dans ${fundName} : ${amountAsCurrency}`;
  };

  const dataValues = graphData.map((fund) => fund.engagement[scope])
  if (!hasNonZeroDataForThisScope(dataValues)) {
    return;
  }

  const data = {
    labels: graphData.map((fund) => fund.short_name),
    datasets: [
      {
        label: 'Engagement',
        data: graphData.map((fund) => fund.engagement[scope]),
        backgroundColor: graphData.map((fund) => fund.color),
        borderWidth: 0.5,
        datalabels: {
          color: colors.white,
          display: function (context) {
            const { dataset, dataIndex } = context;
            const value = dataset.data[dataIndex];
            const total = dataset.data.reduce((acc, v) => acc + v, 0);
            return value / total > 0.1;
          },
          formatter: function (value, context) {
            const { dataset } = context;
            const total = dataset.data.reduce((acc, v) => acc + v, 0);
            const percentage = value / total;

            return numberToPercentage(percentage);
          },
        },
      },
    ],
  };

  const config = {
    type: 'doughnut',
    data: data,
    options: {
      devicePixelRatio: 1.5,
      responsive: true,
      plugins: {
        legend: {
          position: 'bottom',
          labels: legendLabelsConfig,
        },
        title: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: tooltipBody,
          },
        },
      },
    },
  };

  return new Chart(chartCanvas, {
    plugins: [ChartDataLabels],
    ...config,
  });
}

function hasNonZeroDataForThisScope(dataValues) {
  return dataValues.some(value => value !== 0);
}
